import React from "react";
import { KuikaSpinner as KuikaSpinnerSvg } from "../../design-tools/spinner/kuika-spinner";
import "./kuika-spinner.scss";

interface KuikaSpinnerProps {
  /**
   * @deprecated has no visual effect — the overlay always draws the same 120px glyph
   * (general.scss's .kuika-logo-spinner-rect/-logo are fixed-size). Kept in the interface so
   * existing call sites keep compiling; do not read it for new ones.
   */
  size?: "small" | "default" | "large";
  spinning?: boolean;
  className?: string;
  /** Optional caption pill under the spinner — for long-running work ("Updating Approve (2/5)…"). */
  label?: string;
}

const KuikaSpinner: React.FC<KuikaSpinnerProps> = ({ spinning = false, className = "", label }) => {
  if (!spinning) {
    return null;
  }

  return (
    <div className={`kuika-spinner-container kuika-spinner-overlay ${className}`}>
      <div className="kuika-spinner">
        <KuikaSpinnerSvg />
      </div>
      {label ? <div className="kuika-spinner-label">{label}</div> : null}
    </div>
  );
};

export default KuikaSpinner;
